import { Link,useParams,useNavigate, json} from "react-router-dom";
import { APISERVERURL } from './APIServerURL';
import api from './api/posts';
import { useState } from "react";
import Spinner from 'react-bootstrap/Spinner';

function PostPage({posts,accessToken,setAccessToken,mode='user'}) {
  //alert(JSON.stringify(posts));
  const [isLoading,setIsloading]=useState(false);
  const navigate = useNavigate();
  const { id }=useParams();
  const x='something...';
  const post=posts.find(post=>(post._id).toString()===id.toString());
  //alert(JSON.stringify(post));
  let ui=``;
  
    async function handleDelete(e)
    {
      e.preventDefault();
     
      const isConfirmed = window.confirm('Are you sure you want to delete this item?');

        if (isConfirmed) {
          try{
            setIsloading(true);
            await api.post('/employees/deletePost',{id},{headers:{'Authorization':`Bearer ${accessToken}`}});       
            setIsloading(false); navigate('/');
          }
          catch(err)
          {
            try{
              const config = { withCredentials: true };
              const x=await api.get('/getAccessToken',config);
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                 await api.post('/employees/deletePost',{id},{headers:{'Authorization':`Bearer ${nat}`}});
                setIsloading(false); 
                navigate('/');
               }
               catch(err)
               {
                alert('unusual error newposts.js'+err);
                setIsloading(false);
               }
            }
            catch(err)
            {
              alert('failed');
              setIsloading(false);
            }
    
          }
    
        } else {
          // Handle the case when user cancels
          console.log('Delete action cancelled.');
        }
    }
    function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            setIsloading(false);
        });
      });
    }
    async function getPdf(e,img,postId)
    {
      //alert('gett pdf ok1');
      e.preventDefault();
      try{
        //alert(img+" "+postId);
        //post request to deletePhoto wit {id,fileName}
        setIsloading(true);
        const response= await api.post('/employees/getPdf',{id:postId,fileName:img},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        //alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await api.get('/getAccessToken',config);
          //alert(JSON.stringify(x['data']['accessToken']));
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          //console.log(`ne at ${nat}`);
          //console.log(`Second at:${accessToken}`);
          //alert('ok');
          try{       
            const response= await api.post('/employees/getPdf',{id:postId,fileName:img},{headers:{'Authorization':`Bearer ${nat}`}});    
            //alert(JSON.stringify(response.data));
            downloadFile(response.data);
           }
           catch(err)
           {
            alert('unusual error newposts.js');
            setIsloading(false);
            //alert(JSON.stringify(err));
            //navigate('/');
           }
        }
        catch(err)
        {
          alert('failed');
          setIsloading(false);
          //setError(JSON.stringify(err));
          //navigate('/');
        }

      }
    }


    let uimges=``;
  if(post && post.images && post.images.length!==0)
    {
        uimges=post.images.map((image,index)=>{
        return      <div className='imgThumbHome2' key={index}>
                      <img  src={`${APISERVERURL}/img/${image}`} alt="placeholder" />
                      </div>
       })
    }
    else{
        uimges=<p>
        {"0 photos"}
        </p>
    }
    return (
      <main>
        <article className='newPost'>
        <div className="fullWidth baseddDiv"><h3>View Activity</h3> </div>
          {
          post &&
            <>

           <label className="headertext">Ondate:</label>
   <p className="infotext">{post.datetime}</p>

  <label className="headertext">From:</label>
  <p className="infotext">{post.fromTime}</p>

  <label className="headertext">To:</label>
  <p className="infotext">{post.toTime}</p>

  <label className="headertext">Activity:</label>
  <p className="infotext">{post.activity}</p>
  <label className="headertext">Outcome:</label>
  <p className="infotext">{post.outcome}</p>
  <div className='marginTopm'>
        <p>
          Uploaded Photos 
        </p> 
        <div className='album'>
          {uimges}
        </div>
    </div>  
              {(mode!=='admin') && <div className="secondaryNav marginTop">
              <button className='btn btn-primary' style={{fontSize:'13px', letterSpacing:'1.1px'}} onClick={(e)=>{handleDelete(e)}}>DELETE</button>
              <Link to={`/`}><button className='btn btn-success' style={{fontSize:'13px', letterSpacing:'1.1px'}}>HOME</button></Link>
              <Link to={`/edit/${id}`}><button className='btn btn-primary' style={{fontSize:'13px', letterSpacing:'1.1px'}}>EDIT</button></Link>
              </div>
              }
              {(mode==='admin') && <div className="secondaryNav2 marginTop">
              <Link to={`/AdminSearch`}><button className='btn btn-success' style={{fontSize:'13px', letterSpacing:'1.1px'}}>BACK</button></Link>
              </div>
              }
            </>
          }
          {
          !post &&
            <>
              <p>
              Oops!! 404 page not found! Please visit <Link to='/'>our homepage</Link>
              </p> 
            </>
          }
          {isLoading && 
          <div className='spinneroverlay'>
            <div className='spinnerbody'>
              <Spinner animation="border" variant="info" />
              <p>Please wait. It might take a few seconds.</p>
            </div>           
          </div>}
        </article>        
      </main>
    )
  }
  
  export default PostPage